<template>
  <div id="layoutAuthentication" class="h-100">
    <div id="layoutAuthentication_content">
      <main>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-5 mt-5">
              <div class="card shadow-lg border-0 rounded-lg mt-5">
                <div
                  class="card-header mb-0 pb-0 pb-sm-3 pb-md-1 pb-lg-0 row justify-content-center"
                >
                  <div class="col-md-10 col-9 pt-md-1 pt-3">
                    <h4 class="mb-4">Iniciar Sesión</h4>
                  </div>
                  <div class="col-md-2 col-3">
                    <img src="/static/img/icono.png" alt="" class="img-fluid" />
                  </div>
                </div>
                <div class="card-body">
                  <form v-on:submit.prevent="IniciarSesion">
                    <div class="form-group">
                      <label class="small mb-1" for="inputEmailAddress"
                        >Email</label
                      >
                      <input
                        :disabled="cargando || !menu.ready"
                        v-model="email"
                        required
                        class="form-control py-4"
                        id="inputEmailAddress"
                        type="email"
                        placeholder="Email"
                      />
                    </div>
                    <div v-if="!forgot" class="form-group">
                      <label class="small mb-1" for="inputPassword"
                        >Contraseña</label
                      >
                      <input
                        :disabled="cargando || !menu.ready"
                        v-model="password"
                        required
                        class="form-control py-4"
                        id="inputPassword"
                        type="password"
                        placeholder="Contraseña"
                      />
                    </div>
                    <div class="form-group text-right mt-1 mb-0">
                      <button
                        v-if="!forgot"
                        :disabled="cargando || !menu.ready"
                        class="btn btn-innovation"
                        type="submit"
                      >
                        <span
                          v-if="cargando || !menu.ready"
                          class="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Iniciar
                      </button>
                      <button
                        v-else
                        :disabled="cargando || !menu.ready"
                        class="btn btn-innovation"
                        type="submit"
                      >
                        <span
                          v-if="cargando || !menu.ready"
                          class="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Enviar link
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div id="layoutAuthentication_footer">
      <footer class="footer mt-auto footer-dark">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 small">
              Copyright &copy; PSICOFAST 2021
            </div>
            <div class="col-md-6 text-md-right small">
              <a href="https://psicofast.com/privacidad.html">
                Política de Privacidad
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { functions, api } from "@/firebase.js";
export default {
  data() {
    return {
      cargando: false,
      email: "",
      forgot: false,
      password: ""
    };
  },
  methods: {
    IniciarSesion() {
      var that = this;
      if (this.forgot) {
        this.ForgotPassword();
      } else {
        if (!this.Validar()) {
          return;
        }
        this.cargando = true;
        api("IniciarSesion")({
          email: that.email,
          password: md5(that.password),
          cliente: that.cliente
        })
          .then(response => {
            if (response.data.resp) {
              that.loginUsuario(response.data.usuario);
            } else {
              that.cargando = false;
              swal(response.data.error, "", "warning");
            }
          })
          .catch(error => {
            console.log(error);
            that.cargando = false;
            swal(
              "Problemas para iniciar sesión",
              "Favor de intentar mas tarde",
              "error"
            );
          });
      }
    },
    ForgotPassword() {
      var that = this;
      if (this.email.length == 0) {
        swal("Email Obligatorio", "", "warning");
      } else {
        this.cargando = true;
        auth
          .sendPasswordResetEmail(that.email)
          .then(function() {
            swal("Link enviado", "Revisa tu bandeja de entrada", "success");
            that.forgot = false;
          })
          .catch(function(error) {
            console.log(error);
            swal("Error", "Problemas para enviar el link", "error");
          })
          .finally(response => {
            that.cargando = false;
          });
      }
    },
    Validar() {
      var pasar = true;
      if (this.email.length == 0) {
        swal("Email Obligatorio", "", "info");
        pasar = false;
      } else if (this.password.length == 0) {
        swal("Contraseña Obligatoria", "", "info");
        pasar = false;
      }
      return pasar;
    },
    EjecutarRuta(route_name) {
      this.$router.push({ name: route_name });
    },
    Nada() {},
    ...mapActions(["loginUsuario", "logoutUsuario"])
  },
  computed: {
    ...mapState(["menu", "cliente"])
  },
  created() {
    if (this.cliente.id == null) {
      this.$router.push({ name: "Cliente" });
    } else {
      this.menu.ready = true;
    }
    $("body").addClass("bg-innovation");
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AppLogin/Login/Login.vue